'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _values2 = require('lodash/values');

var _values3 = _interopRequireDefault(_values2);

var _toString2 = require('lodash/toString');

var _toString3 = _interopRequireDefault(_toString2);

var _sortBy2 = require('lodash/sortBy');

var _sortBy3 = _interopRequireDefault(_sortBy2);

var _reverse2 = require('lodash/reverse');

var _reverse3 = _interopRequireDefault(_reverse2);

var _omitBy2 = require('lodash/omitBy');

var _omitBy3 = _interopRequireDefault(_omitBy2);

var _omit2 = require('lodash/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _keys2 = require('lodash/keys');

var _keys3 = _interopRequireDefault(_keys2);

var _includes2 = require('lodash/includes');

var _includes3 = _interopRequireDefault(_includes2);

var _groupBy2 = require('lodash/groupBy');

var _groupBy3 = _interopRequireDefault(_groupBy2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _flatten2 = require('lodash/flatten');

var _flatten3 = _interopRequireDefault(_flatten2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _common = require('../common');

var _constants = require('../../constants');

var _util = require('../../utils/util');

var _commonFacet = require('../common-facet');

var _ApplicationListTypeDropdown = require('../page-case/main-applications/ApplicationListTypeDropdown');

var _ApplicationListTypeDropdown2 = _interopRequireDefault(_ApplicationListTypeDropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var REPRESENTATIVES_UNASSIGNED = _constants.AppConstants.REPRESENTATIVES_UNASSIGNED;
var RejectedApplicationsSidebar = (_dec = (0, _mobxReact.inject)('OptionsStore', 'UiStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(RejectedApplicationsSidebar, _Component);

  function RejectedApplicationsSidebar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RejectedApplicationsSidebar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RejectedApplicationsSidebar.__proto__ || Object.getPrototypeOf(RejectedApplicationsSidebar)).call.apply(_ref, [this].concat(args))), _this), _this.isResetting = false, _initDefineProp(_this, 'rejectedReasonFilter', _descriptor, _this), _initDefineProp(_this, 'representativeFilter', _descriptor2, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RejectedApplicationsSidebar, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var filters = nextProps.UiStore.rejectedApplicationsPage.filters,
          applicationStatusTransitionReasons = nextProps.OptionsStore.applicationStatusTransitionReasons;


      this.representativeFilter = (0, _omit3.default)(filters, 'reason');

      if (filters.reason) {
        var reasonFilters = filters.reason.split(','),
            newRejectedReasonFilter = {};

        applicationStatusTransitionReasons.forEach(function (reason) {
          newRejectedReasonFilter[reason.id] = reasonFilters.indexOf((0, _toString3.default)(reason.id)) !== -1;
        });

        this.rejectedReasonFilter = newRejectedReasonFilter;
      }
    }
  }, {
    key: 'changeFilters',
    value: function changeFilters() {
      var _props = this.props,
          changeFilters = _props.changeFilters,
          rejectedApplicationsPage = _props.UiStore.rejectedApplicationsPage;

      rejectedApplicationsPage.filters = this.filters;
      changeFilters(this.isResetting);
    }
  }, {
    key: 'onRepresentativeChange',
    value: function onRepresentativeChange(filterParams) {
      this.representativeFilter = filterParams;
      this.changeFilters();
    }
  }, {
    key: 'onReasonChange',
    value: function onReasonChange(reasonId) {
      this.rejectedReasonFilter[reasonId] = !this.rejectedReasonFilter[reasonId];
      this.changeFilters();
    }
  }, {
    key: 'resetReasonFilters',
    value: function resetReasonFilters() {
      this.isResetting = true;
      this.rejectedReasonFilter = {};
      this.changeFilters();
      this.isResetting = false;
    }
  }, {
    key: 'sortedOptions',
    value: function sortedOptions(options) {
      var sidebarCounts = this.props.sidebarCounts;

      return (0, _reverse3.default)((0, _sortBy3.default)(options, function (option) {
        return (0, _get3.default)(sidebarCounts, option.id, 0);
      })).map(function (option) {
        return _extends({}, option, {
          name: option.reason.description,
          value: option.id
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          changeTableType = _props2.changeTableType,
          sidebarCounts = _props2.sidebarCounts,
          tableType = _props2.tableType,
          resetDisabled = !(0, _includes3.default)((0, _values3.default)(this.rejectedReasonFilter), true);


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_ApplicationListTypeDropdown2.default, {
          changeTableType: changeTableType,
          tableType: tableType
        }),
        _react2.default.createElement(_common.RepresentativeDropdownFilter, {
          loggedInUserLabel: 'My Applications',
          onFilterChange: this.onRepresentativeChange,
          selectedRepresentative: this.selectedRepresentative,
          showAll: true,
          showUnassigned: true
        }),
        _react2.default.createElement('hr', null),
        _react2.default.createElement(_commonFacet.FacetListGroups, {
          facetOptionGroups: this.facetOptionGroups,
          fieldName: 'rejected_reason',
          label: 'Rejected Reason',
          onChange: this.onReasonChange,
          rejectedReasonFilter: this.rejectedReasonFilter,
          reset: this.resetReasonFilters,
          resetDisabled: resetDisabled,
          sidebarCounts: sidebarCounts,
          sortedOptions: this.sortedOptions
        })
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'filters',
    get: function get() {
      var checkedReasons = (0, _omitBy3.default)(this.rejectedReasonFilter, function (checked) {
        return !checked;
      }),
          reasonIds = (0, _keys3.default)(checkedReasons),
          filters = _extends({}, this.representativeFilter, {
        reason: (0, _flatten3.default)(reasonIds).join(',') || null
      });

      return (0, _omitBy3.default)(filters, _util.isEmptyOrNil);
    }
  }, {
    key: 'selectedRepresentative',
    get: function get() {
      var rejectedApplicationsPage = this.props.UiStore.rejectedApplicationsPage;

      if (rejectedApplicationsPage.filters.is_unassigned) {
        return REPRESENTATIVES_UNASSIGNED;
      }
      return rejectedApplicationsPage.filters.representative;
    }
  }, {
    key: 'facetOptionGroups',
    get: function get() {
      var _this2 = this;

      var applicationStatusTransitionReasons = this.props.OptionsStore.applicationStatusTransitionReasons,
          facetOptionGroups = (0, _groupBy3.default)(applicationStatusTransitionReasons, function (r) {
        return r.reason.type;
      });


      Object.keys(facetOptionGroups).forEach(function (key) {
        var options = facetOptionGroups[key];
        facetOptionGroups[key] = _this2.sortedOptions(options).map(function (option) {
          return _extends({}, option, {
            checked: (0, _get3.default)(_this2.rejectedReasonFilter, option.value, false)
          });
        });
      });

      return facetOptionGroups;
    }
  }]);

  return RejectedApplicationsSidebar;
}(_react.Component), _class3.defaultProps = {
  changeFilters: _noop3.default,
  sidebarCounts: undefined
}, _class3.propTypes = {
  changeFilters: _propTypes2.default.func.isRequired,
  changeTableType: _propTypes2.default.func.isRequired,
  OptionsStore: _propTypes2.default.object.isRequired,
  sidebarCounts: _propTypes2.default.object,
  tableType: _propTypes2.default.string,
  UiStore: _propTypes2.default.object.isRequired
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'rejectedReasonFilter', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'representativeFilter', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'filters', [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, 'filters'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'selectedRepresentative', [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, 'selectedRepresentative'), _class2.prototype)), _class2)) || _class) || _class) || _class);
var _default = RejectedApplicationsSidebar;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(REPRESENTATIVES_UNASSIGNED, 'REPRESENTATIVES_UNASSIGNED', '/app/src/components/page-applications-rejected/RejectedApplicationsSidebar.js');
  reactHotLoader.register(RejectedApplicationsSidebar, 'RejectedApplicationsSidebar', '/app/src/components/page-applications-rejected/RejectedApplicationsSidebar.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-applications-rejected/RejectedApplicationsSidebar.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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